import React from 'react';
import * as styles from './styles.scss';

const Input = ({
    id,
    label,
    name,
    className,
    ...props
}) => (
    <div className={styles.checkbox || className}>
        <input
            id={id || name}
            name={name}
            type="checkbox"
            {...props}
        />
        {
            label &&
            <label htmlFor={id || name}>
                {label}
            </label>
        }
    </div>
);

export default Input;
